import {Box, BoxProps, useStyleConfig} from '@chakra-ui/react';
import React, {memo} from 'react';

interface Props extends BoxProps {
  variant?: string;
}

export const UiCard = memo(function UiCard({variant, ...rest}: Props) {
  const styles = useStyleConfig('Card', {variant});
  return <Box __css={styles} {...rest} />;
});
